import axios, { AxiosPromise } from 'axios';
import { IDefaultResponse, AppConfig } from '@ve/types';
import { ISimilarHotel } from '../types/similarHotels';

interface ExWindow extends Window {
  appConfig: AppConfig
}

declare let window: ExWindow;
export interface ISimilarHotelsParams {
    category: number
    country: number
}

export const getSimilarHotels = (
    similarHotelsParams: Partial<ISimilarHotelsParams>,
): AxiosPromise<IDefaultResponse<ISimilarHotel[]>> => {
    const actionParams = {
        countryId: similarHotelsParams.country,
        categoryId: similarHotelsParams.category,
    };

    return axios({
        url: `${window.appConfig.apiGatewayUrl}/frontend/directory/hotels/recommended`,
        method: 'GET',
        params: actionParams,
    });
};
